<template>
  <div class="contacts-page row">
    <div class="left-wrap medium-12">
      <survey-header
        :header-title="pageTitle"
        :button-text="$t('SURVEY_MGMT.SURVEY.HEADER_BTN_TXT')"
        @open-add-modal="openAddModel"
      />
      <ve-table
        :fixed-header="true"
        max-height="calc(100vh - 11.4rem)"
        scroll-width="187rem"
        :columns="columns"
        :table-data="getSurveys"
        :border-around="false"
        row-key-field-name="id"
      />
      <woot-modal
        v-if="!enableSmartSurveys"
        :show.sync="showAddModel"
        :on-close="closeAddModel"
        size="medium"
      >
        <woot-modal-header>
          <h5>
            {{ $t('SURVEY_MGMT.MODELS.MODAL.DISABLED') }}
          </h5>
        </woot-modal-header>
        <div class="warning-container">
          <p v-html="$t('SURVEY_MGMT.MODELS.MODAL.DISABLED_DESCRIPTION')" />
          <a
            class="btn-primary"
            href="http://wa.me/553198795790"
            target="_blank"
          >
            {{ $t('SURVEY_MGMT.MODELS.MODAL.CLICK_HERE') }}
          </a>
        </div>
      </woot-modal>
      <div v-if="enableSmartSurveys">
        <woot-modal
          :show.sync="showAddModel"
          :on-close="closeAddModel"
          size="medium"
        >
          <blank-survey v-if="!selectedModel" @on-close="closeAddModel" />
        </woot-modal>
        <woot-modal
          :show.sync="showSendModal"
          :on-close="closeSendModal"
          size="medium"
        >
          <send-survey
            :survey="selectedSurvey"
            :send-type="sendType"
            @on-close="closeSendModal"
          />
        </woot-modal>
        <woot-modal
          :show.sync="showEmbedModal"
          :on-close="closeEmbedModal"
          size="medium"
        >
          <woot-modal-header :header-title="'Configurar embed da pesquisa'" />
          <div class="embed-settings">
            <div class="embed-tabs">
              <button
                type="button"
                class="embed-tab"
                :class="{ 'embed-tab--active': activeEmbedTab === 'format' }"
                @click="activeEmbedTab = 'format'"
              >
                Formato de exibição
              </button>
              <button
                type="button"
                class="embed-tab"
                :class="{ 'embed-tab--active': activeEmbedTab === 'rules' }"
                @click="activeEmbedTab = 'rules'"
              >
                Regras de Exibição
              </button>
            </div>

            <div v-if="activeEmbedTab === 'format'" class="embed-tab-content">
              <div class="medium-12 columns">
              <label class="radio-group-label">Formato de exibição</label>
              <div class="layout-option-group">
                <label
                  v-for="option in layoutOptions"
                  :key="option.value"
                  class="layout-option"
                  :class="{
                    'layout-option--active':
                      embedSettings.layout === option.value,
                  }"
                >
                  <input
                    v-model="embedSettings.layout"
                    class="radio-input"
                    type="radio"
                    :value="option.value"
                  />
                  <div class="layout-option__copy">
                    <span class="layout-option__title">{{ option.title }}</span>
                    <span class="layout-option__description">{{
                      option.description
                    }}</span>
                  </div>
                  <div
                    class="layout-thumbnail"
                    :class="`layout-thumbnail--${option.value}`"
                    aria-hidden="true"
                  >
                    <div class="layout-thumbnail__browser">
                      <div class="layout-thumbnail__chrome">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <div class="layout-thumbnail__viewport">
                        <div
                          v-if="option.value === 'slide'"
                          class="layout-thumbnail__card"
                        >
                          <span
                            class="layout-thumbnail__line layout-thumbnail__line--short"
                          ></span>
                          <span class="layout-thumbnail__line"></span>
                          <span class="layout-thumbnail__btn"></span>
                        </div>
                        <div
                          v-else-if="option.value === 'modal'"
                          class="layout-thumbnail__overlay"
                        >
                          <div class="layout-thumbnail__card">
                            <span class="layout-thumbnail__close"></span>
                            <span
                              class="layout-thumbnail__line layout-thumbnail__line--short"
                            ></span>
                            <span class="layout-thumbnail__line"></span>
                            <span class="layout-thumbnail__btn"></span>
                          </div>
                        </div>
                        <div
                          v-else-if="option.value === 'tab'"
                          class="layout-thumbnail__tab"
                        >
                          ›
                        </div>
                        <div v-else class="layout-thumbnail__bar">
                          <span class="layout-thumbnail__pill"></span>
                          <span class="layout-thumbnail__pill"></span>
                          <span class="layout-thumbnail__chevron-up"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <div
              class="medium-12 columns embed-field"
              :class="{ 'embed-field--disabled': !isLauncherFieldEnabled }"
            >
              <label class="embed-field__label">
                Texto do botão de chamada
                <span class="embed-field__info">
                  <fluent-icon icon="info" size="14" />
                  <span class="embed-field__tooltip">{{
                    launcherTitleTooltip
                  }}</span>
                </span>
              </label>
              <div class="embed-field__control">
                <input
                  v-model.trim="embedSettings.launcher_title"
                  type="text"
                  placeholder="Ex.: Responda à pesquisa"
                  :disabled="!isLauncherFieldEnabled"
                />
                <fluent-icon
                  v-if="!isLauncherFieldEnabled"
                  icon="lock-closed"
                  size="16"
                  class="embed-field__lock"
                />
              </div>
            </div>
            <div class="medium-12 columns embed-field">
              <div class="embed-color-field">
                <label class="radio-group-label">Cor principal</label>
                <span class="embed-color-hint">
                  Personaliza botões, barra de progresso, estados selecionados
                  e o widget (balão/barra/aba).
                </span>
                <div class="embed-color-control">
                  <woot-color-picker v-model="embedSettings.color" />
                </div>
              </div>
            </div>
            <div
              class="medium-12 columns embed-field"
              :class="{ 'embed-field--disabled': !isPositionFieldEnabled }"
            >
              <label class="radio-group-label">
                Posição da pesquisa na tela
              </label>
              <div class="radio-group">
                <label class="radio-group-item-label">
                  <input
                    v-model="embedSettings.position"
                    class="radio-input"
                    type="radio"
                    value="right"
                    :disabled="!isPositionFieldEnabled"
                  />
                  <span>Direita</span>
                </label>
                <label class="radio-group-item-label">
                  <input
                    v-model="embedSettings.position"
                    class="radio-input"
                    type="radio"
                    value="left"
                    :disabled="!isPositionFieldEnabled"
                  />
                  <span>Esquerda</span>
                </label>
              </div>
            </div>
              <div class="medium-12 columns embed-actions">
                <woot-button type="button" @click="activeEmbedTab = 'rules'">
                  Próximo: Regras
                </woot-button>
              </div>
            </div>

            <div v-if="activeEmbedTab === 'rules'" class="embed-tab-content">
              <div class="medium-12 columns">
                <label class="radio-group-label">Frequência de exibição</label>
                <select v-model="embedDisplayRules.recurrence" class="embed-select">
                  <option
                    v-for="option in recurrenceOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.title }}
                  </option>
                </select>
                <p class="embed-option-description">
                  {{ recurrenceOptions.find(o => o.value === embedDisplayRules.recurrence).description }}
                </p>
                <woot-input
                  v-if="embedDisplayRules.recurrence === 'once_per_period'"
                  v-model.number="embedDisplayRules.period_days"
                  label="Intervalo em dias"
                  type="number"
                  min="1"
                  class="medium-12 columns"
                />
              </div>

              <div class="medium-12 columns">
                <woot-input
                  v-model.number="embedDisplayRules.max_impressions"
                  label="Máximo de exibições por visitante"
                  type="number"
                  min="1"
                  placeholder="Sem limite"
                  class="medium-12 columns"
                />
              </div>

              <div class="medium-12 columns">
                <label class="radio-group-label">Comportamento ao fechar</label>
                <select v-model="embedDisplayRules.dismiss_action" class="embed-select">
                  <option
                    v-for="option in dismissOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.title }}
                  </option>
                </select>
                <p class="embed-option-description">
                  {{ dismissOptions.find(o => o.value === embedDisplayRules.dismiss_action).description }}
                </p>
                <woot-input
                  v-if="embedDisplayRules.dismiss_action === 'snooze'"
                  v-model.number="embedDisplayRules.snooze_days"
                  label="Dias de snooze"
                  type="number"
                  min="1"
                  class="medium-12 columns"
                />
              </div>

              <div class="medium-12 columns">
                <woot-input
                  v-model.number="embedDisplayRules.stop_after_dismissals"
                  label="Parar automaticamente após X fechamentos consecutivos"
                  type="number"
                  min="1"
                  class="medium-12 columns"
                />
                <p class="embed-hint">
                  As regras de anti-fadiga e limites são salvas no navegador do visitante via cookie e localStorage.
                </p>
              </div>

              <div class="medium-12 columns embed-actions">
                <woot-button
                  type="button"
                  variant="smooth"
                  @click="activeEmbedTab = 'format'"
                >
                  Voltar
                </woot-button>
                <woot-button
                  class="bg-primary"
                  :is-loading="loading"
                  @click="generateEmbedScript"
                >
                  Salvar e Gerar código
                </woot-button>
              </div>
            </div>

            <div v-if="embedScript" class="medium-12 columns embed-script-output">
              <woot-code :script="embedScript" lang="html" />
            </div>
          </div>
        </woot-modal>
        <woot-modal
          :show.sync="showDeleteModal"
          :on-close="closeDeleteModal"
          size="medium"
        >
          <woot-confirm-delete-modal
            v-if="showDeleteModal"
            :show.sync="showDeleteModal"
            :title="$t('SURVEY_MGMT.MODELS.DELETE.TITLE')"
            :message="$t('SURVEY_MGMT.MODELS.DELETE.MESSAGE')"
            :confirm-text="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_TEXT')"
            reject-text="Cancelar"
            :confirm-value="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_VALUE')"
            :confirm-place-holder-text="
              $t('SURVEY_MGMT.MODELS.DELETE.PLACEHOLDER')
            "
            @on-confirm="confirmSurveyDelete"
            @on-close="closeDeleteModal"
          />
        </woot-modal>
        <woot-modal
          :show.sync="showCampaignModal"
          :on-close="closeCampaignModal"
          size="medium"
        >
          <add-campaign
            :default-message="surveyMessage"
            campaign-force-type="one_off"
            @on-close="closeCampaignModal"
          />
        </woot-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VeTable } from 'vue-easytable';
import SurveyHeader from './Header';
import alertMixin from 'shared/mixins/alertMixin';
import BlankSurvey from './BlankSurvey.vue';
import SendSurvey from './SendSurvey.vue';
import getUuid from '../../../../../widget/helpers/completeUuid';
import AddCampaign from '../../settings/campaigns/AddCampaign.vue';

export default {
  components: {
    SurveyHeader,
    BlankSurvey,
    VeTable,
    SendSurvey,
    AddCampaign,
  },
  mixins: [alertMixin],

  data() {
    return {
      averageCellWidth: 15,
      intCellWidth: 5,
      kanbanId: 0,
      showAddModel: false,
      loading: false,
      kanbanMeta: {},
      heading: 'Teste',
      content: 'content',
      src: 'src',
      buttonText: 'Selecionar Modelo',
      selectedModel: null,
      selectedSurvey: null,
      showDeleteModal: false,
      showCampaignModal: false,
      showSendModal: false,
      sendType: 'email',
      surveyMessage: '',
      showEmbedModal: false,
      selectedEmbedSurvey: null,
      embedScript: '',
      activeEmbedTab: 'format',
      embedSettings: {
        layout: 'slide',
        position: 'right',
        color: '#01C6D8',
        launcher_title: '',
      },
      launcherTitleTooltip:
        'Disponível apenas para Aba Lateral e Footer Bar. Texto exibido na aba ou barra para convidar o visitante a abrir a pesquisa.',
      embedDisplayRules: {
        recurrence: 'always',
        period_days: 90,
        max_impressions: null,
        dismiss_action: 'session',
        snooze_days: 7,
        stop_after_dismissals: 2,
      },
      layoutOptions: [
        {
          value: 'slide',
          title: 'Slide-in',
          description: 'Desliza do canto inferior, menos invasivo.',
        },
        {
          value: 'modal',
          title: 'Modal / Popup',
          description:
            'Aparece centralizado sobre o site com fundo escurecido.',
        },
        {
          value: 'tab',
          title: 'Aba Lateral',
          description:
            'Aba fixa na lateral, sempre visível, expande ao clicar.',
        },
        {
          value: 'footer',
          title: 'Footer Bar',
          description: 'Barra fixa no rodapé, expande para cima ao clicar.',
        },
      ],
      recurrenceOptions: [
        {
          value: 'once_ever',
          title: 'Apenas uma vez',
          description: 'Exibe a pesquisa somente uma vez para cada visitante.',
        },
        {
          value: 'once_per_session',
          title: 'Uma vez por sessão',
          description: 'Exibe a pesquisa apenas uma vez durante a sessão atual.',
        },
        {
          value: 'once_per_period',
          title: 'Uma vez a cada X dias',
          description: 'Define um intervalo de dias para exibir novamente.',
        },
        {
          value: 'until_answered',
          title: 'Até o usuário responder',
          description: 'Só para de exibir quando a pesquisa for concluída.',
        },
        {
          value: 'always',
          title: 'Toda vez que a página for carregada',
          description: 'Útil para testes (QA).',
        },
      ],
      dismissOptions: [
        {
          value: 'session',
          title: 'Ocultar até fechar o navegador/sessão',
          description: 'Só exibe novamente em uma nova sessão.',
        },
        {
          value: 'snooze',
          title: 'Adiar reexibição por X dias (Snooze)',
          description: 'Define quantos dias esperar antes de mostrar de novo.',
        },
        {
          value: 'never_again',
          title: 'Nunca mais exibir para este visitante',
          description: 'Para de exibir a partir do fechamento.',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      kanbanList: 'getKanbanfunnels',
      currentAccountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
      getSurveys: 'customSurveys/getAllSurveys',
    }),
    columns() {
      return [
        {
          field: 'name',
          key: 'name',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.NAME'),
          display: 'flex',
          property: 'name',
          rowKey: ({ row }) => row.id,
          width: this.averageCellWidth,
          renderBodyCell: ({ row }) => (
            <div class="text-truncate user-email-white">{row.name}</div>
          ),
        },
        {
          field: 'description',
          key: 'description',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.DESCRIPTION'),
          rowKey: ({ row }) => row.id,
          width: this.averageCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.description)
              return (
                <div class="text-truncate user-email-white">
                  {row.description}
                </div>
              );
            return '---';
          },
        },
        {
          field: 'responses',
          key: 'responses',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.RESPONSES'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses)
              return (
                <div class="text-truncate user-email-white">
                  {row.responses.length}
                </div>
              );
            return '0';
          },
        },
        {
          field: 'average',
          key: 'average',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.AVERAGE'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses) {
              const averageRating = row.responses.reduce(
                (acc, response) => {
                  const ratingA = response.questions.find(
                    q => q.type === 'rating_a'
                  );

                  const rating =
                    !ratingA &&
                    response.questions.find(
                      q => q.type === 'rating' && q.required === true
                    );

                  let validRating = null;
                  if (ratingA) {
                    validRating = ratingA.response;
                  } else if (rating) {
                    validRating = rating.response;
                  }

                  if (validRating !== null) {
                    acc.sum += validRating;
                    acc.count += 1;
                  }

                  return acc;
                },
                { sum: 0, count: 0 }
              );

              const average =
                averageRating.count > 0
                  ? (averageRating.sum / averageRating.count).toFixed(2)
                  : '0';

              return (
                <div class="text-truncate user-email-white">{average}</div>
              );
            }

            return '0';
          },
        },
        {
          field: 'promoters',
          key: 'promoters',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.PROMOTER'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses) {
              const validRatingsCount = row.responses.reduce(
                (count, response) => {
                  const ratingA = response.questions.find(
                    q =>
                      q.type === 'rating_a' &&
                      (q.response === 9 || q.response === 10)
                  );

                  const rating =
                    !ratingA &&
                    response.questions.find(
                      q =>
                        q.type === 'rating' &&
                        q.required === true &&
                        (q.response === 4 || q.response === 5)
                    );
                  return count + (ratingA || rating ? 1 : 0);
                },
                0
              );

              return (
                <div class="text-truncate user-email-white">
                  {validRatingsCount}
                </div>
              );
            }

            return '0';
          },
        },
        {
          field: 'neutre',
          key: 'neutre',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.NEUTRE'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses) {
              const validRatingsCount = row.responses.reduce(
                (count, response) => {
                  const ratingA = response.questions.find(
                    q =>
                      q.type === 'rating_a' &&
                      (q.response === 7 || q.response === 8)
                  );

                  const rating =
                    !ratingA &&
                    response.questions.find(
                      q =>
                        q.type === 'rating' &&
                        q.required === true &&
                        q.response === 3
                    );

                  return count + (ratingA || rating ? 1 : 0);
                },
                0
              );

              return (
                <div class="text-truncate user-email-white">
                  {validRatingsCount}
                </div>
              );
            }

            return '0';
          },
        },
        {
          field: 'detrator',
          key: 'detrator',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.DETRACTOR'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses) {
              const validRatingsCount = row.responses.reduce(
                (count, response) => {
                  const ratingA = response.questions.find(
                    q => q.type === 'rating_a' && q.response < 7
                  );

                  const rating =
                    !ratingA &&
                    response.questions.find(
                      q =>
                        q.type === 'rating' &&
                        q.required === true &&
                        (q.response === 1 || q.response === 2)
                    );

                  return count + (ratingA || rating ? 1 : 0);
                },
                0
              );

              return (
                <div class="text-truncate user-email-white">
                  {validRatingsCount}
                </div>
              );
            }

            return '0';
          },
        },
        {
          field: 'actions',
          key: 'actions',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.ACTIONS'),
          width: 6,
          align: 'center',
          renderBodyCell: ({ row }) => (
            <div>
              <div class="actions-grid">
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.getUrl(row);
                  }}
                  class="new-message bg-primary"
                  icon="clipboard"
                  size="small"
                  v-tooltip={`${this.$t(
                    'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.COPY'
                  )}`}
                  variant="smooth"
                />
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.openEmbedModal(row);
                  }}
                  class="new-message bg-primary"
                  icon="code"
                  size="small"
                  v-tooltip="Embed"
                  variant="smooth"
                />
                <router-link
                  to={`/app/accounts/${this.$route.params.accountId}/survey/${row.uuid}`}
                >
                  <woot-button
                    class="new-message bg-primary"
                    icon="eye-show"
                    size="small"
                    v-tooltip={`${this.$t(
                      'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.VIEW'
                    )}`}
                    variant="smooth"
                  />
                </router-link>
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.openSendModal(row, 'whatsapp');
                  }}
                  class="new-message bg-primary"
                  icon="send"
                  size="small"
                  v-tooltip={`${this.$t(
                    'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.SEND'
                  )}`}
                  variant="smooth"
                />
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.openCampaignModal(row);
                  }}
                  class="new-message bg-primary"
                  icon="people"
                  size="small"
                  v-tooltip={`${this.$t(
                    'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.SEND_CAMPAIGN'
                  )}`}
                  variant="smooth"
                />
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.openDeleteModal(row);
                  }}
                  class="new-message bg-primary"
                  icon="delete"
                  size="small"
                  v-tooltip={`${this.$t(
                    'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.DELETE'
                  )}`}
                  variant="smooth"
                  color-scheme="alert"
                />
              </div>
            </div>
          ),
        },
      ];
    },
    pageTitle() {
      return this.$t('SURVEY_MGMT.SURVEY.HEADER');
    },
    enableSmartSurveys() {
      const account = this.getAccount(this.currentAccountId);
      return account?.enable_smart_surveys;
    },
    isLauncherFieldEnabled() {
      return ['tab', 'footer'].includes(this.embedSettings.layout);
    },
    isPositionFieldEnabled() {
      return ['slide', 'tab'].includes(this.embedSettings.layout);
    },
  },

  watch: {},
  mounted() {
    this.$store.dispatch('customSurveys/getSurvey');
    this.$store.dispatch('agents/get');
  },
  methods: {
    getUrl(survey) {
      const baseUrl = window.location.origin;
      const url = `${baseUrl}/survey/custom_surveys/${getUuid()}&${
        survey.uuid
      }`;

      window.open(url);

      return url;
    },
    getAllUrl(survey) {
      const baseUrl = window.location.origin;
      const url = `${baseUrl}/survey/custom_surveys/&${survey.uuid}`;

      return url;
    },
    openDeleteModal(survey) {
      this.selectedSurvey = survey;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    openCampaignModal(survey) {
      this.surveyMessage = this.getAllUrl(survey);
      this.showCampaignModal = true;
    },
    closeCampaignModal() {
      this.showCampaignModal = false;
    },

    confirmSurveyDelete() {
      this.deleteSurvey(this.selectedSurvey.id);
      this.selectedSurvey = null;
      this.closeDeleteModal();
    },

    deleteSurvey(id) {
      this.$store
        .dispatch('customSurveys/deleteSurvey', { id })
        .then(() => {
          this.showAlert(this.$t('SURVEY_MGMT.SURVEY.DELETE.SUCCESS_MESSAGE'));
        })
        .catch(error => {
          const errorMessage =
            error?.response?.message ||
            this.$t('SURVEY_MGMT.SURVEY.DELETE.ERROR_MESSAGE');
          // eslint-disable-next-line no-console
          console.error(error);
          this.showAlert(errorMessage);
        });
    },

    openSendModal(survey, type) {
      this.selectedSurvey = survey;
      this.sendType = type;
      this.showSendModal = true;
    },
    closeSendModal() {
      this.showSendModal = false;
    },
    openEmbedModal(survey) {
      this.selectedEmbedSurvey = survey;
      this.embedScript = '';
      this.activeEmbedTab = 'format';
      this.embedDisplayRules = {
        recurrence: 'always',
        period_days: 90,
        max_impressions: null,
        dismiss_action: 'session',
        snooze_days: 7,
        stop_after_dismissals: 2,
        ...(survey.display_rules || {}),
      };
      this.showEmbedModal = true;
    },
    closeEmbedModal() {
      this.showEmbedModal = false;
      this.selectedEmbedSurvey = null;
      this.embedScript = '';
      this.activeEmbedTab = 'format';
      this.embedDisplayRules = {
        recurrence: 'always',
        period_days: 90,
        max_impressions: null,
        dismiss_action: 'session',
        snooze_days: 7,
        stop_after_dismissals: 2,
      };
    },
    async generateEmbedScript() {
      if (!this.selectedEmbedSurvey) return;
      try {
        this.loading = true;
        const payload = {
          uuid: this.selectedEmbedSurvey.uuid,
          display_rules: this.embedDisplayRules,
        };
        await this.$store.dispatch('customSurveys/updateSurvey', payload);
        const script = await this.$store.dispatch(
          'customSurveys/getEmbedScript',
          {
            id: this.selectedEmbedSurvey.uuid,
            settings: this.embedSettings,
          }
        );
        this.embedScript = script;
        this.activeEmbedTab = 'format';
      } catch (error) {
        this.showAlert('Erro ao salvar regras ou gerar script de embed');
      } finally {
        this.loading = false;
      }
    },
    openAddModel() {
      this.selectedModel = null;
      this.showAddModel = true;
    },
    closeAddModel() {
      this.showAddModel = false;
    },
    openEditModel(model) {
      this.selectedModel = model;
      this.showAddModel = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts-page {
  width: 100%;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 30px;
}

.loading {
  text-align: center;
}

.left-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.actions-grid {
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-self: center;
}
.actions-grid .woot-button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  display: none;
}
.warning-container {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  padding: 0 0 15px 0;
  gap: 6px;
}
.modal-container p {
  font-size: 1.4rem;
  margin: 10px 0px 0px 25px;
  padding: 0;
}
.embed-settings {
  padding: 0.8rem 2rem 2.4rem;
}
.embed-settings .columns {
  margin-bottom: 1.6rem;
}
.radio-group-label {
  color: var(--color-heading);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  margin-bottom: var(--space-small);
}
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
.radio-group-item-label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: var(--color-heading);
  font-size: var(--font-size-small);
  gap: var(--space-small);
}
.radio-input {
  accent-color: var(--w-500, #1f93ff);
  margin: 0;
  flex-shrink: 0;
}
.embed-tabs {
  display: flex;
  gap: 0.5rem;
  border-bottom: 1px solid var(--b-300, #dadde1);
  margin-bottom: 1rem;
}
.embed-tab {
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-weight: 500;
  color: var(--s-500, #6b7280);
  margin-bottom: -1px;
}
.embed-tab:hover {
  color: var(--w-500, #1f93ff);
}
.embed-tab--active {
  color: var(--w-500, #1f93ff);
  border-bottom-color: var(--w-500, #1f93ff);
}
.embed-tab-content {
  padding-top: 0.5rem;
}
.embed-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--b-300, #dadde1);
  border-radius: 6px;
  background: var(--white, #fff);
  margin-top: 0.5rem;
}
.embed-option-description {
  font-size: 0.75rem;
  color: var(--s-500, #6b7280);
  margin: 0.25rem 0 0.5rem;
}
.embed-hint {
  font-size: 0.75rem;
  color: var(--s-500, #6b7280);
  margin: 0.25rem 0;
}
.embed-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin-top: 1rem;
}
.embed-script-output {
  margin-top: 1rem;
}
.layout-option-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.2rem;
  margin-top: var(--space-small);
}
.layout-option {
  border: 1px solid #dbe1e8;
  border-radius: 12px;
  padding: 1.2rem 1.4rem;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.2rem;
  margin-bottom: 0;
  background: #fff;
  transition: border-color 0.15s ease, background 0.15s ease,
    box-shadow 0.15s ease;
}
.layout-option:hover {
  border-color: var(--w-400, #47a6ff);
}
.layout-option--active {
  border-color: var(--w-400, #47a6ff);
  background: #f4f9ff;
  box-shadow: 0 0 0 1px var(--w-400, #47a6ff);
}
.layout-option .radio-input {
  align-self: flex-start;
  margin-top: 0.3rem;
}
.layout-option__copy {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  flex: 1;
}
.layout-option__title {
  color: var(--color-heading);
  font-weight: var(--font-weight-bold);
  font-size: 1.5rem;
  line-height: 1.3;
}
.layout-option__description {
  color: #6b7c8a;
  font-size: 1.3rem;
  line-height: 1.35;
}
.layout-thumbnail {
  width: 14.8rem;
  flex-shrink: 0;
}
.layout-thumbnail__browser {
  background: #fff;
  border: 1px solid #d7dee5;
  border-radius: 8px;
  overflow: hidden;
}
.layout-thumbnail__chrome {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 8px;
  background: #f4f6f8;
  border-bottom: 1px solid #e6ebef;
}
.layout-thumbnail__chrome span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c5cdd3;
}
.layout-thumbnail__viewport {
  position: relative;
  height: 8.2rem;
  background: #f7f8fa;
}
.layout-thumbnail__card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
  padding: 8px 6px 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
}
.layout-thumbnail--slide .layout-thumbnail__card {
  position: absolute;
  right: 7px;
  bottom: 7px;
  width: 38%;
  height: 56%;
}
.layout-thumbnail__overlay {
  position: absolute;
  inset: 0;
  background: #9aa3ad;
  display: flex;
  align-items: center;
  justify-content: center;
}
.layout-thumbnail--modal .layout-thumbnail__card {
  width: 48%;
  height: 64%;
}
.layout-thumbnail__line {
  display: block;
  height: 3px;
  width: 100%;
  background: #e5e7eb;
  border-radius: 2px;
}
.layout-thumbnail__line--short {
  width: 72%;
}
.layout-thumbnail__btn {
  margin-top: auto;
  height: 8px;
  width: 70%;
  background: #3b82f6;
  border-radius: 4px;
}
.layout-thumbnail__close {
  position: absolute;
  top: 3px;
  right: 4px;
  width: 7px;
  height: 7px;
}
.layout-thumbnail__close::before,
.layout-thumbnail__close::after {
  content: '';
  position: absolute;
  left: 3px;
  top: 0;
  width: 1px;
  height: 7px;
  background: #9aa3ad;
}
.layout-thumbnail__close::before {
  transform: rotate(45deg);
}
.layout-thumbnail__close::after {
  transform: rotate(-45deg);
}
.layout-thumbnail__tab {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1.6rem;
  height: 3.6rem;
  background: #93c5fd;
  border-radius: 4px 0 0 4px;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.layout-thumbnail__bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1.8rem;
  background: #3b82f6;
  display: flex;
  align-items: center;
  padding: 0 0.8rem;
  gap: 0.6rem;
}
.layout-thumbnail__pill {
  width: 2.2rem;
  height: 0.6rem;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 999px;
}
.layout-thumbnail__chevron-up {
  margin-left: auto;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 5px solid #fff;
}
.embed-field__label {
  display: inline-flex;
  align-items: center;
  gap: var(--space-smaller);
  color: var(--color-heading);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  margin-bottom: var(--space-smaller);
}
.embed-field__info {
  color: var(--s-400, #93afc8);
  cursor: help;
  display: inline-flex;
  align-items: center;
  position: relative;
}
.embed-field__tooltip {
  position: absolute;
  left: calc(100% + 1rem);
  top: 50%;
  transform: translateY(-50%);
  width: 24rem;
  background: #fff;
  color: #5b6773;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4;
  padding: 0.8rem 1rem;
  border-radius: 8px;
  border: 1px solid #e6ebef;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  z-index: 30;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
.embed-field__tooltip::before {
  content: '';
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: #fff;
}
.embed-field__info:hover .embed-field__tooltip {
  opacity: 1;
  visibility: visible;
}
.embed-field {
  overflow: visible;
}
.embed-field__control {
  position: relative;
}
.embed-field__control input {
  margin-bottom: 0;
}
.embed-field__lock {
  position: absolute;
  right: 1.2rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--s-400, #93afc8);
  pointer-events: none;
}
.embed-field--disabled .embed-field__control input:disabled {
  background: #f3f4f6;
  border-color: #e5e7eb;
  color: #c0c6cc;
  cursor: not-allowed;
  opacity: 1;
  padding-right: var(--space-large);
}
.embed-field--disabled .radio-group-item-label {
  color: var(--s-400, #93afc8);
  cursor: not-allowed;
}
.embed-field--disabled .radio-input {
  cursor: not-allowed;
}
.embed-color-field {
  display: block;
  width: 100%;
  text-align: left;
}
.embed-color-field .radio-group-label {
  display: block;
  text-align: left;
}
.embed-color-hint {
  display: block;
  margin: 0 0 0.6rem;
  font-size: 1.2rem;
  color: var(--s-500);
  line-height: 1.4;
}
.embed-color-control {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  border: 1px solid #e2e8ee;
  border-radius: 12px;
  background: #fff;
  width: fit-content;
  max-width: 100%;
  float: none;
  clear: both;
}
.embed-color-control ::v-deep .colorpicker,
.embed-color-control ::v-deep .colorpicker--selected {
  width: 2.8rem !important;
  height: 2.8rem !important;
  margin: 0 !important;
}
.embed-color-control ::v-deep .colorpicker--selected {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.embed-color-control--disabled {
  background: #f4f5f7;
  pointer-events: none;
}
.embed-color-control--disabled ::v-deep .colorpicker--selected {
  background-color: #eceff2 !important;
  border-color: #e5e7eb;
  cursor: not-allowed;
}
.embed-color-control__lock {
  color: #9aa3ad;
  flex-shrink: 0;
}
.embed-generate-btn {
  background: var(--g-20, #01c6d8) !important;
  border-color: var(--g-20, #01c6d8) !important;
  color: #fff !important;
  border-radius: 8px;
  padding-left: 1.8rem;
  padding-right: 1.8rem;
}
</style>
